import {
  FETCH_PROFILE_START, FETCH_PROFILE_SUCCESS, FETCH_PROFILE_ERROR,
  UPDATE_PROFILE_SUCCESS, UPLOAD_AVATAR_SUCCESS, UPLOAD_COVER_SUCCESS,
  FETCH_NOTIF_PREFS_SUCCESS, UPDATE_NOTIF_PREFS_SUCCESS,
} from '../../Action/actionTypes'

const DEFAULT_NOTIF_PREFS = {
  campaignInvite:       true,
  payments:             true,
  messages:             true,
  disputes:             true,
  weekly:               false,
  announcements:        true,
  email_notifications:  true,
  push_notifications:   true,
  in_app_notifications: true,
}

const initialState = {
  profile: null,
  loading: false,
  error: null,
  notifPrefs: DEFAULT_NOTIF_PREFS,
}

const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROFILE_START:
      return { ...state, loading: true, error: null }
    case FETCH_PROFILE_SUCCESS:
      return { ...state, loading: false, profile: action.payload.profile ?? action.payload }
    case FETCH_PROFILE_ERROR:
      return { ...state, loading: false, error: action.payload }
    case UPDATE_PROFILE_SUCCESS:
      return { ...state, profile: { ...state.profile, ...(action.payload.profile ?? {}) } }
    case UPLOAD_AVATAR_SUCCESS:
      return { ...state, profile: { ...state.profile, avatar_url: action.payload.avatar_url } }
    case UPLOAD_COVER_SUCCESS:
      return { ...state, profile: { ...state.profile, cover_photo_url: action.payload.cover_photo_url } }
    case FETCH_NOTIF_PREFS_SUCCESS:
    case UPDATE_NOTIF_PREFS_SUCCESS:
      return { ...state, notifPrefs: { ...DEFAULT_NOTIF_PREFS, ...(action.payload.preferences ?? {}) } }
    default:
      return state
  }
}

export default settingsReducer
